import { SHOW_EMBEDDED_VIEW, EMBEDDED_VENDOR, APP_MODULE } from 'portal-modules/common/constants/keys'
import { APEX_MODULE } from 'portal-modules/common/constants/apex-keys'

const showEmbeddedView =
  window?.rpSettings?.loginFromExternalClient ||
  sessionStorage.getItem(SHOW_EMBEDDED_VIEW) ||
  false

export const getEmbeddedViewFlag = () => {
  return showEmbeddedView ? true : false
}

export const getApexModule = () => {
  return sessionStorage.getItem(APEX_MODULE)
}

export const getAppModule = () => {
  return sessionStorage.getItem(APP_MODULE)
}